import { useMutation, useQueryClient } from '@tanstack/react-query';
import GeospatialQueries, { GEOSPATIAL_QUERY_KEYS } from '../query';
import type { ReverseGeocodeData, ReverseGeocodeVariables } from '../types';

export const useReverseGeocodeMutation = () => {
  const queryClient = useQueryClient();
  return useMutation<ReverseGeocodeData, unknown, ReverseGeocodeVariables>({
    mutationFn: async ({ location, local, useLocal }) => {
      const resolvedLocal = local ?? useLocal ?? false;
      return GeospatialQueries.reverseGeocode(location, resolvedLocal);
    },
    onSuccess: async (data, variables) => {
      const resolvedLocal = variables.local ?? variables.useLocal ?? false;

      queryClient.setQueryData([GEOSPATIAL_QUERY_KEYS.REVERSE_GEOCODE, variables.location, resolvedLocal], data);
      if (data?.address?.City?.includes('District') || data?.address?.City?.includes('Township')) {
        console.warn('Local City cannot be determined. Using generic API call');
        await queryClient.fetchQuery({
          queryKey: [GEOSPATIAL_QUERY_KEYS.REVERSE_GEOCODE, variables.location, true],
          queryFn: () => GeospatialQueries.reverseGeocode(variables.location, true),
        });
      }
    },
    onError: (error, variables) => {
      const resolvedLocal = variables.local ?? variables.useLocal ?? false;
      //@TODO handle error appropriately, e.g., show an error modal or toast
      queryClient.setQueryData([GEOSPATIAL_QUERY_KEYS.REVERSE_GEOCODE, variables.location, resolvedLocal], undefined);
      console.error('Reverse geocode mutation failed:', error);
    },
  });
};
